<div class="col-12">
  <p-table
    #dt
    [value]="areas()"
    [rows]="env.rowsPerPage[0]"
    [paginator]="true"
    [globalFilterFields]="['name', 'surcharge']"
    styleClass="p-datatable-gridlines p-datatable-striped"
    [rowsPerPageOptions]="env.rowsPerPage"
    [rowHover]="true"
    dataKey="id"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [showCurrentPageReport]="true"
  >
    <ng-template pTemplate="caption">
      <div class="flex">
        <button
          pButton
          label="Clear"
          class="p-button-outlined"
          icon="pi pi-filter-slash"
          (click)="dt.clear()"
        ></button>
        <span class="p-input-icon-left ml-auto">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="dt.filterGlobal($event.target.value, 'contains')"
            placeholder="Search keyword"
          />
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">
          Area
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th pSortableColumn="code">
          Area Code
          <p-sortIcon field="code"></p-sortIcon>
        </th>
        <th pSortableColumn="surcharge">
          Surcharge
          <p-sortIcon field="surcharge"></p-sortIcon>
        </th>
        <th class="text-center">
          Action
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-area>
      <tr>
        <td>{{ area.name }}</td>
        <td>{{ area.code }}</td>
        <td>$ {{ area.surcharge || 0 | number: '1.2-2' }}</td>
        <td class="text-center">
          <button
            pButton
            [disabled]="isSurchargeEditRestricted()"
            type="button"
            icon="pi pi-pencil"
            class="p-button-rounded p-button-success"
            (click)="onEditSurcharge(area)"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  [(visible)]="editDialog"
  [style]="{width: '650px'}"
  header="Edit Area Surcharge: {{updatedArea()?.name}}"
  [modal]="true"
  styleClass="p-fluid"
>
  <ng-template pTemplate="content">
    <form [formGroup]="surchargeForm" (ngSubmit)="onSaveSurcharge()" class="dialog-form">
      <div class="dialog-content">
        <div class="field flex flex-row align-items-start justify-content-between">
          <div class="field flex flex-column flex-grow-1 mr-3">
            <tj-field label="Surcharge" [control]="surchargeForm.controls['surcharge']">
              <tj-money-input formControlName="surcharge" placeholder="100"></tj-money-input>
            </tj-field>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <div class="flex flex-grow-1 justify-content-end">
          <div>
            <button
              pButton
              pRipple
              type="button"
              label="Cancel"
              icon="pi pi-times"
              class="p-button-text"
              (click)="onHideEditDialog()"
            ></button>
          </div>
          <div>
            <button
              pButton
              pRipple
              [disabled]="!surchargeForm.valid"
              type="submit"
              label="Save"
              icon="pi pi-check"
              class="p-button-text"
            ></button>
          </div>
        </div>
      </div>
    </form>
  </ng-template>
</p-dialog>
